// covered-by: frontends/carrie/src/routes/ask-puntt/components/__tests__/ChatMessage.test.tsx

import i18n from "../../../i18n/config";

/** The line the review skill reads. It stays on the stored message. */
const REVIEW_IDS_LINE = /^\s*\*\*Review ids:\*\*/i;

/** The canned project-start line christo stores. The bubble does not leave it in English. */
export const PROJECT_START_GREETING =
  "Let's get started! Just upload your asset or brief and give me an approximate due date — I'll handle the rest.";

/**
 * The text a chat bubble draws.
 *
 * why: `Review ids` is how the skill keeps the English ids after the names
 * are translated. That line is not for the person reading the thread.
 */
export function visibleChatText(content: string): string {
  if (!content.includes("Review ids")) return content;
  return content
    .split("\n")
    .filter((line) => !REVIEW_IDS_LINE.test(line))
    .join("\n");
}

/**
 * The project-start bubble in the viewer's saved language.
 *
 * why: the stored message stays the English sentence, so an old project is not rewritten; an empty saved language stays that sentence.
 */
export function projectStartGreetingBubble(
  content: string,
  uiLanguage: string | null | undefined,
): string {
  if (content !== PROJECT_START_GREETING) return content;
  const base = (uiLanguage ?? "").trim().toLowerCase().split("-")[0];
  // Stryker disable next-line ConditionalExpression: removes all three mutants on the next line. base === "en" -> false is equivalent because i18n.t with lng "en" returns the en ui sentence, which is this exact greeting. base === "" -> false and -> true are not equivalent; the disable hides them, and the empty-language and Spanish assertions in ChatMessage.test.tsx kill them.
  if (base === "" || base === "en") return PROJECT_START_GREETING;
  return i18n.t("askPuntt.projectStartGreeting", { lng: base, ns: "ui" });
}
